import {
  APIComponentAttributes,
  APIComponentType,
  ArdoqId,
  ProvenanceSource,
} from '@ardoq/api-types';
import { ComponentRepresentationDataWithColorShades } from '@ardoq/basic-components';
import { TypeOption } from '@ardoq/component-hierarchies';
import { actionCreator } from '@ardoq/rxbeach';

export type AddChildDialogOpenPayload = {
  component: APIComponentAttributes;
  componentRepresentationData: ComponentRepresentationDataWithColorShades;
  typeOptions: TypeOption[];
  componentTypes: APIComponentType[];
  provenanceSource?: ProvenanceSource;
};

export type RequestOpenAddChildDialogPayload = {
  componentId: ArdoqId;
  provenanceSource?: ProvenanceSource;
};

export const requestOpenAddChildDialog =
  actionCreator<RequestOpenAddChildDialogPayload>(
    '[add child dialog] REQUEST_OPEN_ADD_CHILD_DIALOG'
  );

export const openAddChildDialog = actionCreator<AddChildDialogOpenPayload>(
  '[add child dialog] OPEN_ADD_CHILD_DIALOG'
);
export const closeAddChildDialog = actionCreator(
  '[add child dialog] CLOSE_ADD_CHILD_DIALOG'
);

export const nameChanged = actionCreator<string>(
  '[add child dialog] NAME_CHANGED'
);

export const typeOptionSelected = actionCreator<TypeOption | null>(
  '[add child dialog] TYPE_OPTION_SELECTED'
);
